module.exports = __webpack_public_path__ + "img/common.c34d4c65.svg";